enum SameSite {
  Strict = 'strict',
  Lax = 'lax',
  None = 'none',
}

export default SameSite;
